import {EMPLOYEE} from "@/constants/usersTypes"
import $router from "@/router"

export default {
  methods: {
    handleInteractionError(e, shouldAddError = true) {
      if (e.response && e.response.data && e.response.data.data === false) {
        if (this.$store.state.user.profile.user_type === EMPLOYEE) {
          return $router.push({name: 'account-my-vacancies'})
        } else {
          return $router.push({name: 'account-received-resume'})
        }
      }
      const error = e.response && e.response.data && (e.response.data.message || e.response.message) || e.message

      if (shouldAddError) {
        this.error = error
      }

      return error
    },
  }
}